// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"94":"6c5bc4af","189":"0378a738","256":"5d4194ae","639":"93d96799","711":"26bafdf5","966":"add1a1b8"}[chunkId] + ".chunk.css";
};